export default `vec3 Q,S;
    float i,d=1.,a;
    Q=S=mod(p,8.)-4.;
    a=1.;
    for(int j=0;j++<9;a=a/d+1.)
      Q=2.*clamp(Q,-.7,.7)-Q,
      d=clamp(dot(Q,Q),.5,1.)*.5,
      Q=Q/d+S;
    return max((length(Q)-6.)/a,dot(sin(p),cos(p.yzx))+1.2)*0.6;
  }`